import { Language, ModelStringKeyConditionInput } from '@/API';
import {
  GetLinkListVariables,
  GetLinkList,
  LinkMenuType,
  getLinkList,
} from '@/appsync/graphql/link';
import {
  graphqlQuery,
  getDescriptionByLang,
} from '@/appsync/service/GraphqlUtils';
import { LinkMenu, TenantLandscape } from '@/types/type';

export const LinkMenuLanguage = Language.en;

export const fetchLinkMenus = async (
  param: TenantLandscape
): Promise<LinkMenu[]> => {
  const landscape: ModelStringKeyConditionInput = {
    eq: param.landscape,
  };
  const variables: GetLinkListVariables = {
    tenant: param.tenant,
    landscape,
    limit: 100,
  };
  const result = await graphqlQuery<GetLinkList, GetLinkListVariables>(
    getLinkList,
    variables
  );
  if (result && result.listLinks && result.listLinks.items) {
    return result.listLinks.items
      .sort((menu1, menu2) => menu1.sort - menu2.sort)
      .map(
        (menu: LinkMenuType): LinkMenu => {
          const title = menu.menuDescriptions
            ? getDescriptionByLang(
                menu.menuDescriptions.items,
                LinkMenuLanguage
              )
            : '';
          return {
            id: menu.id,
            title,
            menuType: 'link',
            url: menu.url,
            icon: 'mdi-open-in-new',
          };
        }
      );
  }
  return [];
};
